export default function ServicesIntro() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <p className="text-lg md:text-xl text-gray-700 leading-relaxed text-center">
          Deer Point Contracting is a full-service contracting company providing comprehensive construction services to owners, investors, managers, and general contractors throughout the Mid-Atlantic region and Southeast. Our teams are well versed in exterior and interior scopes of work for multifamily and commercial needs. We deliver the construction expertise, staff, and building materials to accomplish your project.
        </p>
      </div>
    </section>
  );
}